import { ErrorHandler, Injectable } from '@angular/core';
import * as Sentry from '@sentry/angular';

const RECOVERY_KEY = 'chunk-load-recovery-at';
const RECOVERY_COOLDOWN_MS = 30_000;

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {

	private readonly sentryErrorHandler = Sentry.createErrorHandler();

	handleError(error: any): void {

		const errorMessage =
			error?.message ||
			error?.rejection?.message ||
			error?.toString?.() ||
			'';

		const isChunkLoadError =
			errorMessage.includes('Failed to fetch dynamically imported module') ||
			errorMessage.includes('error loading dynamically imported module') ||
			errorMessage.includes('ChunkLoadError') ||
			errorMessage.includes('Loading chunk');

		if (isChunkLoadError && this.canAttemptRecovery()) {
			this.markRecoveryAttempt();
			window.location.reload();
			return;
		}

		this.sentryErrorHandler.handleError(error);
	}

	private canAttemptRecovery(): boolean {
		try {
			const lastAttempt = Number(sessionStorage.getItem(RECOVERY_KEY));
			return !lastAttempt || Date.now() - lastAttempt > RECOVERY_COOLDOWN_MS;
		} catch {
			return false;
		}
	}

	private markRecoveryAttempt(): void {
		try {
			sessionStorage.setItem(RECOVERY_KEY, Date.now().toString());
		} catch { }
	}
}
